import Mdl2025 from "@/UI/Mdl2025";
import { ApiPort } from "$ACTIONS/TLCAPI";
import { get } from "$ACTIONS/TlcRequest";

const gameRestrictionKey = 'game';
const depositRestrictionKey = 'deposit';
const bonusRestrictionKey = 'bonus'; // promotion
const restrictionMap = {
    [gameRestrictionKey]: "disableBetting",
    [depositRestrictionKey]: "disableDeposit",
    [bonusRestrictionKey]: "disableBonusApplication",
};

const FOREVER_ID = 3;

const HAS_LIMIT_VALUE = true;
const NO_LIMIT_VALUE = false;

const DEFUALT_DATE = '';
const DEFUALT_TXT1 = '';
// const DEFUALT_ONCLICK1 = ()=>{};
let SelfExclusionTrait;
export default SelfExclusionTrait = that => {
    return {
        gameRestrictionKey,
        depositRestrictionKey,
        bonusRestrictionKey,
        HAS_LIMIT_VALUE,
        NO_LIMIT_VALUE,
        init: ()=>{
            that.state.showSelfExclusionMdl2025=false;
            that.state.dateSelfExclusionMdl2025=DEFUALT_DATE;
            that.state.txt1SelfExclusionMdl2025=DEFUALT_TXT1;
            // that.onclick1SelfExclusionMdl2025=DEFUALT_ONCLICK1;
        },
        // setupOnclick1SelfExclusionMdl2025: func => that.onclick1SelfExclusionMdl2025=func,
        // resetOnclick1SelfExclusionMdl2025: () => that.onclick1SelfExclusionMdl2025=DEFUALT_ONCLICK1,
        checkSelfExclusion:(type)=>{
            return get(ApiPort.GETSelfExclusions).then((res) => {
                const restrictionField = restrictionMap[type||depositRestrictionKey];
                // res.result.selfExcludeDuration = 90; // debug
                if (res && res.isSuccess && res.result.status && restrictionField && res.result[restrictionField]) {
                    let date = res.result.selfExcludeSetDate.substring(0,10).replace(/-/g,'/');
                    let txt1 = res.result.selfExclusionSettingID != FOREVER_ID ? res.result.selfExcludeDuration+'天' : '永久';
                    that.SelfExclusionTrait.setState4RenderSelfExclusion(true, date, txt1);
                    return [HAS_LIMIT_VALUE];
                }
                return [NO_LIMIT_VALUE];
            });
        },
        state4RenderSelfExclusion: (isShow, date, txt1) => {
            let o = {
                showSelfExclusionMdl2025:isShow,
                dateSelfExclusionMdl2025:isShow ? date : DEFUALT_DATE,
                txt1SelfExclusionMdl2025:isShow ? txt1 : DEFUALT_TXT1,
            };
            return o;
            // that.setState(o)
        },
        setState4RenderSelfExclusion: (isShow, date, txt1) => {
            let o = that.SelfExclusionTrait.state4RenderSelfExclusion(isShow, date, txt1);
            that.setState(o);
        },
        renderSelfExclusion: ()=>{
            return <Mdl2025
                    isShow={that.state.showSelfExclusionMdl2025}
                    hd="自我限制"
                    bdStyle={{width:260,textAlign:'center',margin:'0 auto 20px'}}
                    bd={<>您在 {that.state.dateSelfExclusionMdl2025} 已成功设定<br />({that.state.txt1SelfExclusionMdl2025}) 自我行为控制，如需要任何帮<br />助，请联系在线客服</>}
                    btn2txt="联系客服"
                    onClick1={()=>that.SelfExclusionTrait.setState4RenderSelfExclusion(false)/*+that.onclick1SelfExclusionMdl2025()*/}
                    onClick2={()=>global.PopUpLiveChat()+setTimeout(()=>that.SelfExclusionTrait.setState4RenderSelfExclusion(false),2000)} />
        }
    }
};
